import { CardsConfig, IconType, ItemPerRow, SelectMode } from '@rappider/rappider-components/utils';

export const homeCardsConfig: { cardsConfig: CardsConfig } = {
  cardsConfig: {
    itemCountPerRow: ItemPerRow.Four,
    showTitleOnImage: false,
    showDescriptionOnImage: false,
    showCheckMarkOnCard: false,
    paginationConfig: {
      pageIndex: 1,
      total: 3,
      pageSize: 100,
      showPagination: false,
      nzFrontPagination: false
    },
    selectConfig: {
      options: [],
      settings: {
        mode: SelectMode.Single,
        maxTagCount: 1
      },
      placeholder: 'Filter Tags',
      visibility: false
    },
    items: [],
    inputGroupConfig: {},
    // inputGroupConfig2: {
    //   textbox: {
    //     placeholder: 'Search in Entities',
    //   },
    //   suffixIcon: {
    //     name: 'fas fa-search',
    //     type: IconType.FontAwesome,
    //   }
    // }
  }
};
